import { render, staticRenderFns } from "./DocumentDetails.vue?vue&type=template&id=34523565&"
import script from "./DocumentDetails.vue?vue&type=script&lang=js&"
export * from "./DocumentDetails.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDetails.vue?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/styles/documents.css?vue&type=style&index=1&lang=css&"
import style2 from "@/assets/styles/datepickers.css?vue&type=style&index=2&lang=css&"
import style3 from "@/assets/styles/modals.css?vue&type=style&index=3&lang=css&"
import style4 from "@/assets/styles/tabs.css?vue&type=style&index=4&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports